import PropTypes from 'prop-types';
import classNames from 'classnames';

import './ListingItem.scss';

const ListingItem = ({ className = '', bordered = true, children }) => (
  <section
    className={classNames('listing-section', className, {
      'listing-section--no-border': !bordered
    })}
  >
    {children}
  </section>
);

ListingItem.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array])
    .isRequired,
  className: PropTypes.string,
  bordered: PropTypes.bool
};

export default ListingItem;
